import classNames from "classnames";

import styles from "./StrengthIndicator.module.scss";

type DotIndicatorProps = {
  strength: number;
  isLarge?: boolean;
};

export const DotIndicator = ({ strength, isLarge = false }: DotIndicatorProps) => {
  const dots = Array.from({ length: 6 }, (_, index) => (
    <span
      key={index}
      className={classNames(styles.dot, { [styles.large]: isLarge, [styles.filled]: index < strength })}
    />
  ));

  return <div className={styles.dotIndicator}>{dots}</div>;
};
